import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IDailiesParams } from '@t/api/utilities/dailies/dailies-parameter.model';
import { IWhiteMailState } from '@t/store/utilities-page/whitemail-state';

const initialState: IWhiteMailState = {
  filter: undefined,
};

export const whiteMailSlice = createSlice({
  initialState,
  name: 'whitemail/cart',
  reducers: {
    clearCard: () => {
      return {
        ...initialState,
      };
    },

    setFilter: (state, { payload }: PayloadAction<IDailiesParams>) => {
      state.filter = payload;
    },
  },
});

export const whiteMailReducer = whiteMailSlice.reducer;
